import {ProductionControlModals} from "../../../control_produccion/utils";

export default {
    accordionCollapseStates: [],
    rows:[]
}
